var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "plotchange" }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("plotChangePage.title")))]),
    _c("p", [
      _vm._v(" " + _vm._s(_vm.$t("plotChangePage.description")) + " "),
      _c("br"),
      _vm._v(_vm._s(_vm.$t("plotChangePage.descriptionSuffix")) + " "),
    ]),
    _c("div", { staticClass: "plotchange-cards" }, [
      _c("div", { staticClass: "plotchange-card" }, [
        _c("div", { staticClass: "plotchange-card-title" }, [
          _c("div", { staticClass: "mode-name-column" }, [
            _c("div", [
              _vm._v(_vm._s(_vm.$t("plotChangePage.kishoutenketsuMode"))),
            ]),
          ]),
          _vm.currentMode === "kishoutenketsu"
            ? _c(
                "button",
                { staticClass: "selected", attrs: { disabled: "" } },
                [_vm._v(_vm._s(_vm.$t("plotChangePage.selected")))]
              )
            : _c(
                "button",
                {
                  staticClass: "change",
                  on: {
                    click: function ($event) {
                      return _vm.changePlotMode("kishoutenketsu")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("plotChangePage.changeButton")))]
              ),
        ]),
        _c("div", { staticClass: "plotchange-card-description" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("plotChangePage.kishoutenketsuDescription1")) +
              " "
          ),
          _c("br"),
          _vm._v(
            _vm._s(_vm.$t("plotChangePage.kishoutenketsuDescription2")) + " "
          ),
          _c("br"),
          _vm._v(
            _vm._s(_vm.$t("plotChangePage.kishoutenketsuDescription3")) + " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "plotchange-card" }, [
        _c("div", { staticClass: "plotchange-card-title" }, [
          _c("div", { staticClass: "mode-name-column" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("plotChangePage.johakyuMode")))]),
            _c("img", {
              attrs: { src: require("@/assets/img/icon/premium.png") },
            }),
          ]),
          _vm.currentMode === "johakyu"
            ? _c(
                "button",
                { staticClass: "selected", attrs: { disabled: "" } },
                [_vm._v(_vm._s(_vm.$t("plotChangePage.selected")))]
              )
            : _c(
                "button",
                {
                  staticClass: "change",
                  on: {
                    click: function ($event) {
                      return _vm.changePlotMode("johakyu")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("plotChangePage.changeButton")))]
              ),
        ]),
        _c("div", { staticClass: "plotchange-card-description" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("plotChangePage.johakyuDescription1")) + " "
          ),
          _c("br"),
          _vm._v(_vm._s(_vm.$t("plotChangePage.johakyuDescription2")) + " "),
          _c("br"),
          _vm._v(_vm._s(_vm.$t("plotChangePage.johakyuDescription3")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "plotchange-card" }, [
        _c("div", { staticClass: "plotchange-card-title" }, [
          _c("div", { staticClass: "mode-name-column" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("plotChangePage.customMode")))]),
            _c("img", {
              attrs: { src: require("@/assets/img/icon/premium.png") },
            }),
          ]),
          _vm.currentMode === "custom"
            ? _c(
                "button",
                { staticClass: "selected", attrs: { disabled: "" } },
                [_vm._v(_vm._s(_vm.$t("plotChangePage.selected")))]
              )
            : _c(
                "button",
                {
                  staticClass: "change",
                  on: {
                    click: function ($event) {
                      return _vm.changePlotMode("custom")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("plotChangePage.changeButton")))]
              ),
        ]),
        _c("div", { staticClass: "plotchange-card-description" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("plotChangePage.customDescription1")) + " "
          ),
          _c("br"),
          _vm._v(_vm._s(_vm.$t("plotChangePage.customDescription2")) + " "),
          _c("br"),
          _vm._v(_vm._s(_vm.$t("plotChangePage.customDescription3")) + " "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }